import { render, staticRenderFns } from "./ExchangeBoxList.vue?vue&type=template&id=1069ee26"
import script from "./ExchangeBoxList.vue?vue&type=script&lang=js"
export * from "./ExchangeBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports